import React from "react";
import PaymentStatusLayout from "./PaymentStatusLayout";

import FailSign from "assets/img/fail-sign.png";

const PaymentFailure = () => {
  return (
    <PaymentStatusLayout
      imageSrc={FailSign}
      altText="پرداخت ناموفق"
      alertColor="danger"
      message={<p className="mb-0 p-0">پرداخت انجام نشد!</p>}
      action={{
        text: "لیست تراکنش های من",
        redirect: "/wallet/transaction-list",
      }}
    />
  );
};

export { PaymentFailure };
